import { Button } from "@/components/ui/button";
import type { WantedEditorState } from "../utils/wantedEditorState";
import { wantedEditorStatePresentation } from "../utils/wantedEditorState";

type WantedActionBarProps = {
  readonly editorState: WantedEditorState;
  readonly isBusy: boolean;
  readonly canSave: boolean;
  readonly canSubmit: boolean;
  readonly canReset: boolean;
  readonly onSave: () => void;
  readonly onSubmit: () => void;
  readonly onReset: () => void;
};

export function WantedActionBar({
  editorState,
  isBusy,
  canSave,
  canSubmit,
  canReset,
  onSave,
  onSubmit,
  onReset,
}: WantedActionBarProps) {
  const presentation = wantedEditorStatePresentation[editorState];
  const isVisible =
    editorState === "draft" ||
    editorState === "saved" ||
    editorState === "dirty";

  if (!isVisible) return null;

  return (
    <footer className="fixed inset-x-0 bottom-0 z-30 animate-in fade-in-0 slide-in-from-bottom-5 border-t border-border bg-background/95 px-4 py-3 shadow-[0_-8px_20px_rgba(15,23,42,0.08)] backdrop-blur duration-300 motion-reduce:animate-none sm:px-6 md:bottom-3 md:left-[calc(var(--width-menu)+24px)] md:right-3 md:rounded-b-2xl">
      <div className="mx-auto flex w-full max-w-[1520px] flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-text-main2">
            {presentation.label}
          </p>
          <p className="mt-1 text-xs leading-4 text-text-sub">
            {presentation.description}
          </p>
        </div>
        <div className="flex flex-wrap gap-2 sm:justify-end">
          <Button
            type="button"
            variant="ghost"
            size="lg"
            className="min-h-11 text-text-sub hover:bg-light-muted hover:text-text-main2"
            onClick={onReset}
            disabled={isBusy || !canReset}
          >
            초기화
          </Button>
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="min-h-11 border-border bg-background text-text-main2 hover:bg-light-muted"
            onClick={onSave}
            disabled={isBusy || !canSave}
          >
            임시저장
          </Button>
          {canSubmit && (
            <Button
              type="button"
              size="lg"
              className="min-h-11 bg-sig text-sm font-semibold hover:bg-sig/90"
              onClick={onSubmit}
              disabled={isBusy}
            >
              제출하기
            </Button>
          )}
        </div>
      </div>
    </footer>
  );
}
